/**
 * TanStack Query hooks for `proxy-type-detection-public-private-residential-pr`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	proxyTypeDetectionPublicPrivateResidentialPrQueryKeys,
	type CreateProxyTypeDetectionPublicPrivateResidentialPrBody,
	type ListProxyTypeDetectionPublicPrivateResidentialPrResponse,
	type ProxyTypeDetectionPublicPrivateResidentialPrRow,
} from "./api";

export function useProxyTypeDetectionPublicPrivateResidentialPrList(): UseQueryResult<ListProxyTypeDetectionPublicPrivateResidentialPrResponse, Error> {
	return useQuery({
		queryKey: proxyTypeDetectionPublicPrivateResidentialPrQueryKeys.list(),
		queryFn: list,
	});
}

export function useProxyTypeDetectionPublicPrivateResidentialPrCreate(): UseMutationResult<ProxyTypeDetectionPublicPrivateResidentialPrRow, Error, CreateProxyTypeDetectionPublicPrivateResidentialPrBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: proxyTypeDetectionPublicPrivateResidentialPrQueryKeys.all });
		},
	});
}

export function useProxyTypeDetectionPublicPrivateResidentialPrDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: proxyTypeDetectionPublicPrivateResidentialPrQueryKeys.all });
		},
	});
}
